export default "__VITE_ASSET__BQHHNA0N__"